import React, { useEffect, useState } from 'react';
import "./project.css";
import icon1 from "../../assets/projecticons/design-options-1.svg";
import icon2 from "../../assets/projecticons/cities-1.svg";
import icon3 from "../../assets/projecticons/design-expert-1.svg";
import icon4 from "../../assets/projecticons/interior-projects-1.svg";

function Project() {
  const targetValues = { projects: 502, experts: 197, cities: 12, designs: 490 };
  const duration = 2000; // Total duration in milliseconds
  const frameRate = 60; // Frames per second (smooth animation)
  const totalFrames = (duration / 1000) * frameRate; // Total frames

  const [counts, setCounts] = useState({
    projects: 0,
    experts: 0,
    cities: 0,
    designs: 0
  });

  useEffect(() => {
    let frame = 0;

    function animateCount() {
      frame++;
      setCounts({
        projects: Math.min(Math.ceil((frame / totalFrames) * targetValues.projects), targetValues.projects),
        experts: Math.min(Math.ceil((frame / totalFrames) * targetValues.experts), targetValues.experts),
        cities: Math.min(Math.ceil((frame / totalFrames) * targetValues.cities), targetValues.cities),
        designs: Math.min(Math.ceil((frame / totalFrames) * targetValues.designs), targetValues.designs)
      });

      if (frame < totalFrames) {
        requestAnimationFrame(animateCount);
      }
    }

    requestAnimationFrame(animateCount);
  }, []);

  return (
    <div className="other-details bgGray">
      <div className="container-fluid main-cf">
        <ul>
          <li>
            <figure>
              <img alt="Interior Projects" src={icon1} width="45" height="39" />
            </figure>
            <div>
              <label>{counts.projects}+</label>
              <span>Interior Projects</span>
            </div>
          </li>
          <li>
            <figure>
              <img alt="Design Experts" src={icon2} width="33" height="45" />
            </figure>
            <div>
              <label>{counts.experts}+</label>
              <span>Design Experts</span>
            </div>
          </li>
          <li>
            <figure>
              <img alt="Cities" src={icon3} width="45" height="46" />
            </figure>
            <div>
              <label>{counts.cities}+</label>
              <span>Cities</span>
            </div>
          </li>
          <li>
            <figure>
              <img alt="Design Options" src={icon4} width="45" height="46" />
            </figure>
            <div>
              <label>{counts.designs.toLocaleString()}+</label>
              <span>Happy Clients</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Project;
